/**
 * Device Files Route
 * @description デバイスファイル管理画面のルート定義
 */

import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { DeviceFilesSearchSchema } from "./-zod-schema";

export const Route = createFileRoute(
  "/_staff/profile/device/$id/_profile/files",
)({
  validateSearch: zodValidator(DeviceFilesSearchSchema),
});
